import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BaseService } from './base.service';
import {BaseEntity} from '../base/BaseEntity';

import { Observable } from 'rxjs';
import { IQueryResult } from '../base/interfaces/IQueryResult';
import { IBaseEnumEntity } from '../base/interfaces/IBaseEnumEntity';
import { ReferenceAutoComplete } from '../documents/document-reference/reference-auto-complete';
import { IDocumentResult } from '../base/interfaces/IDocumentResult';

@Injectable({
  providedIn: 'root'
})
export class BaseAutoCompleteService extends BaseService<IBaseEnumEntity> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, null);
   }
   OldQuery(query: string, skip?: number, take?: number): Observable<IQueryResult<IBaseEnumEntity>> {
    let params = new HttpParams();
    if (query) {
      params = params.append('querystring', query);
    }
    if (skip) {
      params = params.append('$skip', skip.toString());
    }
    if (take) {
      params = params.append('$top', take.toString());
    }
    return this.http.get<IQueryResult<IBaseEnumEntity>>(`${this.rootUrl}/${this.endpoint}`, {params: params});
  }

  Query(queryId:string, query:string, skip?: number, take?: number, parameters?: Map<string,string>): Observable<IQueryResult<ReferenceAutoComplete>> {
    let params = new HttpParams();
    if (query) {
      params = params.append('querystring', query);
    }
    if (skip) {
      params = params.append('$skip', skip.toString());
    }
    if (take) {
      params = params.append('$top', take.toString());
    }
    if (query) {
      params = params.append('query', query);
    }
    if(parameters){
      parameters.forEach((value, key)=>{
        params = params.append(key, value);        
      })
    }
    return this.http.get<IQueryResult<ReferenceAutoComplete>>(`${this.rootUrl}/query/autocomplete/${queryId}`, {params: params});
  }
  GetItem(queryId:string, id:string): Observable<ReferenceAutoComplete>{
    return this.http.get<ReferenceAutoComplete>(`${this.rootUrl}/query/autocomplete/${queryId}/${id}`);
  }
}
